import Resource from './BaseResource'

class Setting extends Resource {
    constructor(config, tools, version, path) {
        super(config, tools, version, path)
    }
}

export default Setting
